<script>
export default {
  data() {
    return {
      errors: []
    }
  },
  methods: {
    handleValidationErrors(response) {
      if (response && response.status === 400) {
        this.$nextTick().then(() => {
          this.errors = this.mapGenericErrors(response.data.errors, response.data.message)
          const fieldErrors = this.mapFieldErrors(response.data.fieldErrors)
          this.$refs.form.setErrors(fieldErrors)

          if (this.errors.length === 0 && Object.keys(fieldErrors).length > 0) {
            Object.keys(fieldErrors).forEach(fieldName => {
              if (!this.fieldExists(fieldName)) {
                this.errors.push(this.$t('validation.invalid') + ': ' + fieldName)
              }
            })
          }
        })
      }
    },
    fieldExists(fieldName) {
      return this._fieldExists(fieldName, this.$data.application)
    },
    _fieldExists(fieldName, object) {
      const regex = /^(\w*)\.(.+)/
      const property = fieldName.replace(regex, '$1')
      if (Object.keys(object).indexOf(property) === -1) return false
      if (!fieldName.match(regex)) return true
      const tail = fieldName.replace(regex, '$2')
      return this._fieldExists(tail, object[property])
    },
    translateValidationError(errorCode) {
      if (this.$te(`errors.les.${errorCode}`)) return this.$t(`errors.les.${errorCode}`)
      if (this.$te(`validation.${errorCode}`)) return this.$t(`validation.${errorCode}`)
      return this.$t('validation.invalid')
    },
    mapFieldErrors(fieldErrors) {
      if (!fieldErrors) return []

      const errors = fieldErrors
      Object.entries(errors).forEach(([key, value]) => {
        errors[key] = this.translateValidationError(value[0])
      })
      return errors
    },
    mapGenericErrors(genericErrors, defaultErrorMessage) {
      if (!genericErrors) return [this.cleanupValidationError(defaultErrorMessage)]

      const errors = genericErrors
      Object.entries(errors).forEach(([key, value]) => {
        errors[key] = this.translateValidationError(value)
      })
      return errors
    },
    cleanupValidationError(validationError) {
      if (validationError) {
        return validationError.replace(/^\S+: /, '')
      }
    }
  }
}
</script>
